<div class="cover-card">
  <header class="cover-header">
    <div class="cover-heading">
      <h2>Choose a cover</h2>
      <p *ngIf="eventName">{{ eventName }}</p>
    </div>
    <button type="button" class="cover-close" aria-label="Close" (click)="close()">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      </svg>
    </button>
  </header>

  <nav class="cover-categories">
    <button type="button" class="cover-chip" *ngFor="let category of categories"
      [class.is-active]="category === activeCategory" (click)="selectCategory(category)">
      {{ category }}
    </button>
  </nav>

  <div class="cover-grid">
    <button type="button" class="cover-tile cover-tile--upload" [class.is-selected]="isUploadSelected"
      [class.has-image]="!!imageSrc" (click)="fileInput.click()">
      <img *ngIf="imageSrc" [src]="imageSrc" alt="Uploaded cover" />
      <span class="cover-upload-label" *ngIf="!imageSrc">
        <span class="cover-plus">+</span>
        Upload your own
      </span>
      <span class="cover-check" *ngIf="isUploadSelected">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M2.5 7.3l3 3 6-6.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>
    </button>

    <input type="file" #fileInput class="cover-file" accept="image/png,image/jpeg,image/jpg,image/webp"
      (change)="onFileSelected($event)" />

    <button type="button" class="cover-tile" *ngFor="let cover of covers; trackBy: trackCover"
      [class.is-selected]="cover.id === selectedCover?.id" [attr.aria-label]="cover.category + ' cover'"
      (click)="selectCover(cover)">
      <img [src]="cover.thumb" alt="" loading="lazy" decoding="async" />
      <span class="cover-check" *ngIf="cover.id === selectedCover?.id">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M2.5 7.3l3 3 6-6.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>
    </button>
  </div>

  <footer class="cover-footer">
    <div class="cover-actions">
      <button type="button" class="cover-primary" [disabled]="!canSave" (click)="saveCover()">
        {{ isCompressing ? 'Preparing…' : 'Use this cover' }}
      </button>
      <button type="button" class="cover-cancel" (click)="close()">Cancel</button>
    </div>
  </footer>
</div>
